// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"4924f98d","385":"b5c3ddde"}[chunkId] + ".css";
};